import store from '../../app/store';
import validationsReducer from './validationsReducer';

store.injectReducer('validations', validationsReducer);

export { default } from './Validations';
